module.exports = __webpack_public_path__ + "cv.svg?624a2d4d919439bbd76b1431de002c18";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/cv.svg
// module id = 1312
// module chunks = 0